// lib/api.js
import axios from 'axios';
import { getApiErrorMessage, attachAxiosUserMessage } from './apiError';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const getToken = () => {
  return localStorage.getItem('admin_token');
};

export const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    attachAxiosUserMessage(error, 'Something went wrong. Please try again.');
    return Promise.reject(error);
  }
);

export {
  getApiErrorMessage,
  getBackendErrorMessage,
  getErrorMessageFromBody,
  fetchJsonOrThrow,
} from './apiError';